export const SSN_MASK = '###-##-####';
export const SSN_LENGTH = 9;
export const LAST_4_SSN_LENGTH = 4;
export const LAST_4_SSN_MASK = '####';
//# sourceMappingURL=ssn.js.map